import axios from "axios";

async function generateQuestion(lang = "en") {
  try {
    const result = await axios({
      method: "get",
      url: `${process.env.REACT_APP_ENGINE_API}/api/question/reading?lang=${lang}`,
      headers: {
        'Content-Type': `aplication/json`,
      },
    })
    return result.data.payload
  } catch (error) {
    console.log(error)
    return null
  }
}

export {generateQuestion}